import {connect} from 'react-redux';
import EntitybanksNew from './EntitybanksNew';
import {
  createNewEntitybanks,
  createNewEntitybanksStart,
  createNewEntitybanksComplete,
  cancelCreateNewEntitybanks,
  selectEntitybanksUi,
  entitybanksListIsDirty
} from '../../redux/actions/entitybanks';

const mapStateToProps = state => {
  return {
    app_state: state.app_state,
    entity_banks: state.entity_banks
  };
};

const mapDispatchToProps = dispatch => {
  return {
    createNewEntitybanks: data => {
      dispatch(createNewEntitybanks(data));
    },
    createNewEntitybanksStart: () => {
      dispatch(createNewEntitybanksStart());
    },
    createNewEntitybanksComplete: data => {
      dispatch(createNewEntitybanksComplete(data));
    },
    cancelCreateNewEntitybanks: () => {
      dispatch(cancelCreateNewEntitybanks());
    },
    selectEntitybanksUi: value => {
      dispatch(selectEntitybanksUi(value));
    },
    entitybanksListIsDirty: value => {
      dispatch(entitybanksListIsDirty(value));
    }
  };
};

const EntitybanksNewContainer = connect(mapStateToProps, mapDispatchToProps)(EntitybanksNew);

export default EntitybanksNewContainer;
